define(['jquery', 'marionette'], function ($, Marionette) {
  return Marionette.View.extend({
    el: '#content_layout',

    ui: {
      updateButton: '.update-button',
      updateDatetime: '.update-button #update-datetime',
      shareButton: '.btc-ranking-promotion .share-button',
      hour: '.btc-ranking-promotion .time-wrapper .h',
      minute: '.btc-ranking-promotion .time-wrapper .m',
      second: '.btc-ranking-promotion .time-wrapper .s',
      tooltip: ' .btc-ranking-promotion .share-tooltip',

      /* Toast */
      toast: '#toast_success',
      toastText: '#toast_text_success',
      toastMessage: '#toast-message',
    },

    events: {
      'click @ui.updateButton': 'refreshRanking',
      'click @ui.shareButton': 'shareLink',
    },

    initialize: function () {
      this.bindUIElements();

      this.lang = window.lang || 'en_US';
      this.refreshRanking();

      this.countdown();
    },

    refreshRanking: function () {
      // 1. update the datetime display
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}`;
      this.ui.updateDatetime.text(formattedTime);

      // 2. fetch the ranking data
      const that = this;

      $.ajax({
        url: '/rest_btc_reward_ticket/get_btc_ticket_rank',
        type: 'GET',
        data: {
          lang: that.lang,
        },
        success(response) {
          const rankingData = response.data;
          const tbody = document.getElementById('ranking-body');

          // reset existing tbody
          tbody.innerHTML = '';

          // add ranking data to tbody
          rankingData.forEach((entry, index) => {
            const tr = document.createElement('tr');

            // we use image for top 3 ranks, otherwise just number
            let rankTd = document.createElement('td');
            let rankWrapper = document.createElement('div');
            rankWrapper.className = 'wrapper';

            if (index < 3) {
              let img = document.createElement('img');
              img.src = `/assets/common/main/img/en_US/promotion/btc-ranking/rank-${index + 1}.png`;
              rankWrapper.appendChild(img);
            } else {
              rankWrapper.textContent = index + 1;
            }

            rankTd.appendChild(rankWrapper);
            tr.appendChild(rankTd);

            // country name
            const countryTd = document.createElement('td');
            countryTd.innerHTML = `<div class="wrapper"><img class="flag" src="/assets/common/main/img/en_US/flags/circle/${entry.countryCode}.svg" />${entry.countryName}</div>`;
            tr.appendChild(countryTd);

            // account no
            const accountTd = document.createElement('td');
            accountTd.innerHTML = `<div class="wrapper">${entry.maskedMt4AccountNo}</div>`;
            tr.appendChild(accountTd);

            // ticket
            const ticketTd = document.createElement('td');
            ticketTd.innerHTML = `<div class="wrapper"><div class="ticket">${entry.tickets}</div></div>`;
            tr.appendChild(ticketTd);

            tbody.appendChild(tr);
          });
        },
      });
    },

    shareLink: function () {
      const currentUrl = window.location.href;
      const that = this;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(currentUrl)
          .then(() => {
            that.toast();
          })
          .catch(() => {});
      }
    },

    countdown: function () {
      const deadlineUTC = new Date(Date.UTC(2025, 6, 31, 23, 59, 59));

      const setCountdownText = (h, m, s) => {
        this.ui.hour.text(h.toString().padStart(2, '0'));
        this.ui.minute.text(m.toString().padStart(2, '0'));
        this.ui.second.text(s.toString().padStart(2, '0'));
      };

      const updateCountdown = () => {
        const nowUTC = new Date();
        const diff = deadlineUTC.getTime() - nowUTC.getTime();

        if (diff <= 0) {
          setCountdownText(0, 0, 0);
          clearInterval(timer);
          return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        setCountdownText(hours, minutes, seconds);
      };

      updateCountdown();

      const timer = setInterval(updateCountdown, 1000);
    },

    toast: function () {
      this.ui.toast.addClass('show');

      setTimeout(() => {
        this.ui.toast.removeClass('show');
      }, 2000);
    },
  });
});
